export const month = [
  {
    label: 'January, 2025',
    value: 'January, 2025',
    selected: true,
  },
  {
    label: 'February, 2025',
    value: 'February, 2025',
  },
  {
    label: 'March, 2025',
    value: 'March, 2025',
  },
  {
    label: 'April, 2025',
    value: 'April, 2025',
  },
];

export const fontSize_opentab = 1;